import moment from "moment/moment";
import { useCallback, useEffect, useState } from "react";
import apiPath from "../../Utils/apiPath";
import { apiGet } from "../../Utils/apiFetch";
import { debounce, isEmpty, startCase } from "lodash";
import InternalLoader from "../../component/InternalLoader";
import GameRecordFilter from "./GameRecordFilter";
import { FaCalendarAlt } from "react-icons/fa";
import { isLegacyEdge } from "react-device-detect";
import { formatWithCommas } from "../../Utils/Toast";
import { useNavigate } from "react-router-dom";
const WithdrawRecord = () => {
  const [data, setData] = useState([]);
  const [listing, setListing] = useState([]);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState({
    status: false,
    type: "",
  });
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    fromPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
    toPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
    type: "All",
  });
  const getData = async (obj = filter, type) => {
    const { status, data } = await apiGet(apiPath.withDrawHistory, {
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page,
      limit: obj?.limit
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
        if (type == "add") {
          setListing([...listing, ...data?.results]);
        } else {
          setListing(data?.results);
        }
        setTotal(
          data?.results.reduce((a, b) => {
            return a + b?.amount + (b?.bonus > 0 ? b?.bonus : 0);
          }, 0)
        );
      }
    }
    setLoader(false);
  };
  // Debounce wrapper to avoid multiple API calls
  const debouncedFetch = useCallback(
    debounce((obj) => {
      getData(obj);
    }, 500), // wait 600ms
    []
  );

  // Trigger API when filter changes but debounced
  useEffect(() => {
    setLoader(true);
    debouncedFetch(filter);
  }, [filter]);

  const from = moment(filter?.fromPeriod);
  const to = moment(filter?.toPeriod);

  // 1️⃣ Check if both are today
  const isToday = from.isSame(moment(), "day") && to.isSame(moment(), "day");

  // 2️⃣ Check if range is last 7 days (including today)
  const isLast7Days =
    from.isSame(moment().subtract(6, "days"), "day") &&
    to.isSame(moment(), "day");

  // 3️⃣ Check if both are yesterday
  const isYesterday =
    from.isSame(moment().subtract(1, "day"), "day") &&
    to.isSame(moment().subtract(1, "day"), "day");
  const format = "YYYY-MM-DD HH:mm:ss";

  const setToday = () => {
    return {
      fromPeriod: moment().startOf("day").format(format),
      toPeriod: moment().endOf("day").format(format),
    };
  };

  const setYesterday = () => {
    return {
      fromPeriod: moment().subtract(1, "day").startOf("day").format(format),
      toPeriod: moment().subtract(1, "day").endOf("day").format(format),
    };
  };

  const setLast7Days = () => {
    return {
      fromPeriod: moment().subtract(6, "days").startOf("day").format(format),
      toPeriod: moment().endOf("day").format(format),
    };
  };
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="withdraw-report">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-withdrawReport mc-default-header am-navbar am-navbar-light"
          >
            <div className="am-navbar-left" role="button">
              <span
                onClick={() => navigate(-1)}
                className="am-navbar-left-content"
              >
                <span className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">Withdrawal Record</div>
            <div className="am-navbar-right">
              <div className="to-record">
                <a href="/m/vouReport">
                  <span className="more-icon deposit am-navbar-title">
                    <svg className="am-icon am-icon-deposit_record_b99e1f01 am-icon-md">
                      <use xlinkHref="#deposit_record_b99e1f01" />
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <div className="am-tabs am-tabs-top">
          <div role="tablist" className="am-tabs-bar" tabIndex={0}>
            <div
              className="am-tabs-ink-bar am-tabs-ink-bar-no-animated"
              style={{
                display: "block",
                "-webkit-transform": "translate3d(0px, 0px, 0px)",
                "-ms-transform": "translate3d(0px, 0px, 0px)",
                transform: "translate3d(0px, 0px, 0px)",
                width: "120px",
              }}
            />
            <div
              onClick={() =>
                setFilter((prev) => {
                  return {
                    ...prev,
                    fromPeriod: setToday()?.fromPeriod,
                    toPeriod: setToday()?.toPeriod,
                  };
                })
              }
              role="tab"
              aria-disabled="false"
              aria-selected="true"
              className={`${isToday ? "am-tabs-tab-active" : ""} am-tabs-tab`}
            >
              <span className="am-badge">
                {/* react-text: 5514 */}Today{/* /react-text */}
              </span>
            </div>
            <div
              role="tab"
              aria-disabled="false"
              aria-selected="false"
              className={`${
                isYesterday ? "am-tabs-tab-active" : ""
              } am-tabs-tab`}
              onClick={() =>
                setFilter((prev) => {
                  return {
                    ...prev,
                    fromPeriod: setYesterday()?.fromPeriod,
                    toPeriod: setYesterday()?.toPeriod,
                  };
                })
              }
            >
              <span className="am-badge">Yesterday</span>
            </div>
            <div
              role="tab"
              aria-disabled="false"
              aria-selected="false"
              className={`${
                isLast7Days ? "am-tabs-tab-active" : ""
              } am-tabs-tab`}
              onClick={() =>
                setFilter((prev) => {
                  return {
                    ...prev,
                    fromPeriod: setLast7Days()?.fromPeriod,
                    toPeriod: setLast7Days()?.toPeriod,
                  };
                })
              }
            >
              <span className="am-badge">
                {/* react-text: 5520 */}7-days{/* /react-text */}
              </span>
            </div>
          </div>
          <div className="am-tabs-content am-tabs-content-no-animated">
            <div
              role="tabpanel"
              aria-hidden="false"
              className="am-tabs-tabpane am-tabs-tabpane-active"
            >
              <div className="am-flexbox am-flexbox-align-middle mc-trans-filter  mc-filter ">
                <div className="am-flexbox am-flexbox-align-middle mc-trans-filter ">
                  {/* <a
                    onClick={() =>
                      setShow({
                        status: true,
                        type: "WithdrawType",
                      })
                    }
                    role="button"
                    className="am-button am-button-ghost am-button-small am-button-inline"
                    aria-disabled="false"
                  >
                    <span> {filter?.type}</span>
                  </a> */}

                  <div
                    onClick={() =>
                      setShow({
                        status: true,
                        type: "range",
                      })
                    }
                    className="flex-shrink1 filter-time-btn"
                  >
                    <a
                      role="button"
                      className="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                      aria-disabled="false"
                      style={{
                        "-webkit-flex": "0 0 50%",
                        "-ms-flex": "0 0 50%",
                        flex: "0 0 50%",
                      }}
                    >
                      <FaCalendarAlt className="am-icon am-icon-calendar_c4db3b67 am-icon-xxs" />
                      <span>
                        {" "}
                        {moment(filter?.fromPeriod).format("MM/DD")}-{" "}
                        {moment(filter?.toPeriod).format("MM/DD")}
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="mc-trans-record-container">

                <ul className="scroll-inner-container">
                  {data?.length > 0 ? (
                    data?.map((res) => {
                      return (
                        <li>
                          <div className="records-root other vou vou-record-item">
                            <div className="am-card">
                              <div className="am-card-body">
                                <div className="card-header-wrapper">
                                  <div className="card-header">
                                    <div className="card-header-span">
                                      {startCase(res?.bank_name) ||
                                        startCase(res.bank)}
                                    </div>
                                    <div
                                      className="time"
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      {moment(res?.createdAt).format(
                                        "YYYY-MM-DD hh:mm:ss"
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div className="card-body">
                                  <p className="clearfix">
                                    {/* react-text: 1575 */}Received time
                                    {/* /react-text */}
                                    {/* react-text: 1576 */}：
                                    {/* /react-text */}
                                    {/* react-text: 1577 */}
                                    {moment(res?.createdAt).format(
                                      "YYYY-MM-DD hh:mm:ss"
                                    )}
                                    {/* /react-text */}
                                  </p>
                                  <p className="clearfix">
                                    {/* react-text: 1587 */}Remarks
                                    {/* /react-text */}
                                    {/* react-text: 1588 */}：
                                    {/* /react-text */}
                                    {/* react-text: 1589 */}
                                    {res?.remark || "-"}
                                    {/* /react-text */}
                                  </p>
                                </div>
                                <div className="card-footer">
                                  <ul>
                                    <li>
                                      <p>Request</p>
                                      <p className="requestedAmount">
                                        {formatWithCommas(res?.amount)}
                                      </p>
                                    </li>
                                    <li>
                                      <p>
                                        {/* react-text: 1597 */}{" "}
                                        {/* /react-text */}
                                        {/* react-text: 1598 */}Received amount
                                        {/* /react-text */}
                                      </p>
                                      <p>
                                        {formatWithCommas(
                                          res?.amount +
                                            (res?.bonus > 0 ? res?.bonus : 0)
                                        )}
                                      </p>
                                    </li>
                                    <li>
                                      <p>Status</p>
                                      <p
                                        className={`${
                                          res?.status == "completed"
                                            ? "col2"
                                            : res?.status == "declined"
                                            ? "col3"
                                            : "col5"
                                        }`}
                                      >
                                        {res?.status == "completed" &&
                                        res?.transferedProcess == "process"
                                          ? "Processing"
                                          : res?.status == "completed"
                                          ? "Approve"
                                          : "Decline"}
                                      </p>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <div
                      className="nodata-container"
                      style={{ height: "607.609px" }}
                    >
                      <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                        <use xlinkHref="#nodata_f4c19c2d" />
                      </svg>
                      <p className>No data</p>
                    </div>
                  )}
                </ul>
              </div>
            </div>
            <div
              role="tabpanel"
              aria-hidden="true"
              className="am-tabs-tabpane am-tabs-tabpane-inactive"
            />
            <div
              role="tabpanel"
              aria-hidden="true"
              className="am-tabs-tabpane am-tabs-tabpane-inactive"
            />
          </div>
        </div>
        <div className="records-footer hide">
          <span>
            {/* react-text: 5798 */}Total{/* /react-text */}
            {/* react-text: 5799 */}:{/* /react-text */}
          </span>
          <span>{formatWithCommas(total)}</span>
        </div>
      </div>{" "}
      {show?.status && !isEmpty(show?.type) && (
        <GameRecordFilter
          type={show?.type}
          setFilter={setFilter}
          setShow={setShow}
          filter={filter}
        />
      )}
      {loader && <InternalLoader />}
    </div>
  );
};

export default WithdrawRecord;
